import React, { useState } from 'react'
import MetaTags from 'react-meta-tags'
import {
  Container,
  Col,
  Card,
  CardBody,
  CardHeader,
  Row,
  Modal,
} from 'reactstrap'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import { useHardware } from './hardware.hook'
import HardwareTable from './components/hardware-table/hardware-table.component'
import HardwareFormModal from './components/hardware-form-modal.component'
import DeleteHardware from './components/delete-hardware.component'
import { HardwareDto } from './hardware.type'

const HardwarePage: React.FC = () => {
  const { data, isError, isLoading, refetch } = useHardware()
  const [modalHardware, setModalHardware] = useState<
    HardwareDto | 'new' | null
  >(null)
  const [hardwareToDelete, setHardwareToDelete] = useState<HardwareDto | null>(
    null,
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Hardware</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={'LoPay Support'} breadcrumbItem="Hardware" />
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <p className="card-title-desc">
                        This is a list of hardware that is available for our
                        merchants to purchase in-app.
                      </p>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
                        <button
                          type="button"
                          onClick={() => setModalHardware('new')}
                          className="btn btn-primary"
                        >
                          <i className="bx bx-plus me-1"></i> Add Hardware
                        </button>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <HardwareTable
                    data={data}
                    isError={isError}
                    isLoading={isLoading}
                    onEdit={setModalHardware}
                    onDelete={setHardwareToDelete}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {modalHardware !== null && (
        <HardwareFormModal
          hardware={modalHardware === 'new' ? undefined : modalHardware}
          allHardware={data ?? []}
          onClose={() => setModalHardware(null)}
          onSuccess={() => {
            setModalHardware(null)
            refetch()
          }}
        />
      )}

      {hardwareToDelete && (
        <Modal isOpen toggle={() => setHardwareToDelete(null)} scrollable>
          <DeleteHardware
            hardware={hardwareToDelete}
            onCloseModal={() => setHardwareToDelete(null)}
            onSuccess={() => {
              setHardwareToDelete(null)
              refetch()
            }}
          />
        </Modal>
      )}
    </React.Fragment>
  )
}

export default HardwarePage
